<p style="font-size: 18px; font-weight: bold; padding-left: 20px; margin-bottom: 0;">私にピッタリな留学・ワーホリ先は？</p>
<div style="background-color: #fdf5e6; padding: 20px; margin-top: -4px;">
  <a href="https://ryugaku.yume-kana.com/counseling/" style="font-weight: bold; text-decoration: underline; color: #03c;">👉無料カウンセリングはこちらから</a>
</div>
<p style="color: #dd5943; font-weight: bold; font-size: 14px; margin-top: 0;">これまで累計3万人が相談しています！</p>
